import { createContext } from 'react';

const ScrollableContext = /*#__PURE__*/createContext(undefined);

export { ScrollableContext };
